export default "__VITE_ASSET__BTw1$aib__"